import { Popover, popoverClasses } from "@analyticsMD/quil";
import { grey } from "@mui/material/colors";
import type { SxProps, Theme } from "@mui/material/styles";
import type { FC, ReactNode } from "react";

export const suggestionDetailPopoverPaperSx = {
  [`.${popoverClasses.paper}`]: {
    borderRadius: "0.5rem",
    maxWidth: "26rem",
    minWidth: "17.5rem",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.12)",
    border: `1px solid ${grey[200]}`,
    marginTop: "0.25rem",
  },
};

/** Max width of ARAS score popover paper (design spec). */
export const ARAS_POPOVER_PAPER_MAX_WIDTH = "268px";

export const arasSuggestionDetailPopoverShellSx: SxProps<Theme> = {
  [`.${popoverClasses.paper}`]: {
    maxWidth: ARAS_POPOVER_PAPER_MAX_WIDTH,
    minWidth: 0,
  },
};

export interface SuggestionDetailPopoverShellProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  children: ReactNode;
  /** Merged after default paper styles (e.g. pass {@link arasSuggestionDetailPopoverShellSx}). */
  sx?: SxProps<Theme>;
}

/**
 * Shared Popover chrome for suggestion detail panels (explainability, ARAS, etc.).
 * Inner layout and “Hide” placement live in each content component.
 */
const SuggestionDetailPopoverShell: FC<SuggestionDetailPopoverShellProps> = ({
  open,
  anchorEl,
  onClose,
  children,
  sx: sxProp,
}) => (
  <Popover
    open={open}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    transformOrigin={{ vertical: "top", horizontal: "left" }}
    elevation={2}
    PaperProps={{
      sx: {
        overflow: "hidden",
      },
    }}
    sx={
      sxProp
        ? [suggestionDetailPopoverPaperSx, sxProp]
        : suggestionDetailPopoverPaperSx
    }
  >
    {children}
  </Popover>
);

export default SuggestionDetailPopoverShell;
